module.exports = __webpack_public_path__ + "img/Background.a8bead09.png";